import {
  REQUEST_RECEIPTSTATISTICS,
  REQUEST_RECEIPTSTATISTICS_DONE,
  AverageReceiptStatisticsActions
} from "./types";
import { SalesStatistic } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchAverageReceiptStatistics(): AverageReceiptStatisticsActions {
  return {
    type: REQUEST_RECEIPTSTATISTICS,
    payload: []
  };
}

function fetchAverageReceiptStatisticsDone(
  averageReceiptStatistics: ReadonlyArray<SalesStatistic>
): AverageReceiptStatisticsActions {
  return {
    type: REQUEST_RECEIPTSTATISTICS_DONE,
    payload: averageReceiptStatistics
  };
}

/* Thunks goes here */
export const thunkFetchAverageReceiptStatistics = (
  periodFrom: Date,
  periodTo: Date,
  storeIds: string[] = []
) => async (dispatch: any) => {
  try {
    dispatch(fetchAverageReceiptStatistics());
    const result = await StatisticsApi.getAverageReceiptStatistics(
      periodFrom,
      periodTo,
      storeIds
    );

    if (isOk(result)) {
      dispatch(fetchAverageReceiptStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchAverageReceiptStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
